<template>
<div class="termsAndConditionBody">
    <div class = "loading" :style="`display: ${isSpinner ? 'flex' : 'none'};`" v-if="isSpinner">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
    </div>
  <div v-html="termsAndCondition" v-if="!isSpinner"></div>
</div>
</template>

<script>
const db = firebase.firestore();
import firebase from "@/utils/firebaseInit.js";
import { dbCollections } from "@/utils/firebaseCollection.js";
import {BSpinner} from "bootstrap-vue"
export default {
name: "termsAndConditionDisplay",
components: {
    BSpinner
},
data() {
    return {
        termsAndCondition : "",
        isSpinner: true,
    }
},
created() {
    db.collection(dbCollections.SETTINGS).doc("setting").collection(dbCollections.TAC).doc("termsandcondition").get().then((tac)=>{
        this.termsAndCondition = tac.data().termsAndCondition
        this.isSpinner = false;
    }).catch((error)=>{
        this.isSpinner = false;
        console.error(error,"error")
    })
},
}
</script>
<style>
.termsAndConditionBody { margin: 20px 20px;}
.termsAndConditionBody ul { margin: 0 10px 20px;}
.termsAndConditionBody ol { margin: 0 10px 10px 15px;}
.ql-align-justify {
    text-align: justify;
}
.ql-align-center {
    text-align: center;
}
.ql-align-right {
    text-align: right;
}
</style>